import type { StylePropertiesTypes } from '@wix/document-services-types'
import type { Spx } from '@wix/thunderbolt-becky-types'
import { getConverter } from '../../utils/convertersRegistry'
import { getStringFromConverter } from '../../utils/converterHelpers'

/** Internal Converters */
const singleGapValueConverter = (value: StylePropertiesTypes.SingleGapValue, spx?: Spx): string => {
	const converter = getConverter(value.type)
	if (converter) {
		return getStringFromConverter(converter(value, spx))
	}

	// Fallback for unknown types
	console.warn(`No converter found for SingleGapValue type: ${value.type}`)
	return ''
}

const gapConverter = (prop: StylePropertiesTypes.Gap, spx?: Spx): string => {
	if (prop && prop.type === 'Gap') {
		const columnValue = singleGapValueConverter(prop.columnGap, spx)
		const rowValue = singleGapValueConverter(prop.rowGap, spx)

		// If both values are the same, use shorthand
		if (columnValue === rowValue) {
			return columnValue
		}

		return `${rowValue} ${columnValue}`
	} else {
		// Handle simple SingleGapValue format
		return singleGapValueConverter(prop as StylePropertiesTypes.SingleGapValue, spx)
	}
}

/** External Mapper */
export const gapConverterMap = {
	Gap: gapConverter,
} as Record<string, (prop: StylePropertiesTypes.Gap, spx?: Spx) => string>
